import { teamColor } from '../lib/colors';
import { logo } from '../lib/logo';
import type { TeamSide as Side } from '../lib/api';

/** Logo plus name in the team's color. */
export function TeamChip({ t, size = 28, bold = false }: { t: Partial<Side> & { name?: string }; size?: number; bold?: boolean }) {
  return (
    <span className="inline-flex min-w-0 items-center gap-2">
      {t.logo ? <img src={logo(t.logo, size)} alt="" width={size} height={size} className="shrink-0 object-contain" /> : <span className="shrink-0 rounded-full" style={{ width: size, height: size, background: teamColor(t.color) }} />}
      <span className={`truncate ${bold ? 'font-semibold' : 'font-medium'}`}>{t.name ?? t.abbreviation}</span>
    </span>
  );
}

/**
 * Two-sided probability bar: the away side fills from the left in its color,
 * the home side from the right, and the split is the model's call.
 */
export function ProbabilityBar({ away, home, pAway, pHome, label = 'Win probability' }: { away: Partial<Side>; home: Partial<Side>; pAway: number; pHome: number; label?: string }) {
  const a = Math.round(pAway * 100), h = Math.round(pHome * 100);
  const ca = teamColor(away.color), ch = teamColor(home.color, '#0F4C81');
  return (
    <div className="card p-5">
      <p className="kicker mb-3">{label}</p>
      <div className="flex items-end justify-between gap-4">
        <div className="min-w-0"><TeamChip t={away} size={32} bold={a >= h} /><p className="num mt-1 text-[32px] leading-none" style={{ color: ca }}>{a}%</p></div>
        <div className="min-w-0 text-right"><span className="inline-flex justify-end"><TeamChip t={home} size={32} bold={h > a} /></span><p className="num mt-1 text-[32px] leading-none" style={{ color: ch }}>{h}%</p></div>
      </div>
      <div className="mt-3 flex h-3 w-full overflow-hidden rounded-full bg-wash">
        <div className="h-full transition-[width] duration-700" style={{ width: `${a}%`, background: ca }} />
        <div className="h-full flex-1" style={{ background: ch }} />
      </div>
    </div>
  );
}
